import * as React from "react";

function SvgAdMedia(props, ref) {
  return (
    <svg
      height="1em"
      viewBox="0 0 400 400"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        fill="#FEFEFE"
        opacity="1.000000"
        stroke="none"
        d="
M218.000000,401.000000
	C145.355881,401.000000 73.211761,401.000000 1.033823,401.000000
	C1.033823,267.730896 1.033823,134.461746 1.033823,1.096312
	C134.227402,1.096312 267.454895,1.096312 400.841187,1.096312
	C400.841187,134.333176 400.841187,267.666565 400.841187,401.000000
	C340.128510,401.000000 279.314240,401.000000 218.000000,401.000000
M360.311066,218.049118
	C360.234619,212.728943 360.405853,207.390625 360.018066,202.093231
	C359.550323,195.704620 356.782288,190.404846 350.400909,188.204834
	C342.287170,185.407547 334.481323,186.733398 326.794769,191.000732
	C327.554382,192.934525 328.183777,194.536835 328.808075,196.126129
	C344.386047,190.478058 352.172119,193.474884 351.429291,204.773682
	C349.659454,204.870209 347.795532,204.700775 346.073303,205.117188
	C341.109955,206.317230 335.869843,207.065689 331.353027,209.257812
	C324.506866,212.580444 321.951691,220.299377 324.385895,227.130493
	C326.599670,233.343002 333.127197,236.851654 340.600555,235.800446
	C342.073181,235.593307 343.522888,235.223267 345.289368,235.546432
	C347.821930,236.003860 350.354462,236.461288 352.893280,236.919830
	C352.992188,235.970703 353.059296,235.326599 353.964264,234.826370
	C356.225342,234.841736 358.486389,234.857086 361.560181,235.004944
	C363.627899,235.592133 365.672394,236.285431 367.768250,236.744064
	C371.961975,237.661774 376.400421,237.310486 378.046417,233.046295
	C379.551117,229.148193 380.292297,224.339874 379.367981,220.402695
	C378.960846,218.668488 373.641632,217.401382 370.468994,217.192612
	C367.200134,216.977524 363.829559,218.308212 360.311066,218.049118
M206.989075,185.315842
	C206.624985,180.052597 206.260910,174.789352 205.887375,169.389496
	C202.179001,169.389496 198.874649,169.389496 194.970398,169.389496
	C188.788589,186.705841 182.545990,204.192474 176.300537,221.687103
	C176.035843,221.084457 175.645859,220.360214 175.390656,219.591248
	C170.782104,205.705994 166.268097,191.788773 161.566116,177.935333
	C158.504211,168.914062 158.383835,168.951431 148.907150,169.290665
	C148.626450,169.300720 148.354675,169.560760 147.662735,169.920578
	C146.173965,191.355957 144.669250,213.021072 143.157562,234.786469
	C146.167419,234.786469 148.474716,234.786469 151.262726,234.786469
	C152.288391,217.785156 153.307358,200.894821 154.326324,184.004501
	C155.832367,184.735199 156.357681,185.513977 156.641953,186.372543
	C161.448441,200.889709 166.222015,215.417755 171.011154,229.940659
	C171.770386,232.242981 172.101562,234.478439 175.654922,234.595047
	C179.183395,234.710892 179.758530,232.699478 180.615891,230.299088
	C183.354919,222.630585 186.197617,214.999039 188.924637,207.326324
	C192.111710,198.359192 195.219193,189.363754 198.741867,179.292267
	C199.742905,198.585770 200.679230,216.632141 201.618042,234.726364
	C204.682587,234.726364 207.119217,234.726364 210.051437,234.726364
	C209.031998,218.410080 208.027664,202.335587 206.989075,185.315842
M83.259560,233.258804
	C84.862053,233.183517 86.464539,233.108246 88.417824,233.016479
	C88.084709,231.673737 87.901207,230.733551 87.618477,229.824203
	C82.689980,213.972061 77.801918,198.107010 72.779617,182.284576
	C71.247169,177.456711 70.643860,170.835281 67.241379,168.512970
	C63.702217,166.097351 57.285664,168.026413 52.140297,167.782166
	C49.458160,167.654831 48.446507,168.649765 47.716297,171.185150
	C44.501083,182.348785 41.033764,193.439896 37.648373,204.554413
	C34.773304,213.993484 31.885336,223.428619 28.881853,233.262405
	C32.384071,233.262405 35.247158,232.936401 38.005978,233.333954
	C42.928326,234.043274 44.864262,232.022354 45.995808,227.286316
	C48.576244,216.486023 48.868076,216.973618 60.108143,216.375168
	C66.061172,216.058228 68.449928,218.008560 69.858391,223.610489
	C72.308136,233.354050 72.652664,233.267426 83.259560,233.258804
M90.189331,221.103455
	C92.896828,227.380661 97.123787,232.212067 103.963623,233.784363
	C111.609123,235.541885 118.317764,233.431335 123.664482,226.805466
	C123.963676,229.356369 124.172241,231.134491 124.400513,233.080734
	C128.690842,233.080734 132.800095,233.080734 136.780518,233.080734
	C136.780518,210.057587 136.780518,187.228638 136.780518,164.577423
	C131.678360,164.577423 127.107780,164.577423 122.153412,164.577423
	C122.153412,172.844162 122.153412,180.742432 122.153412,188.893433
	C107.008507,178.859116 91.446510,188.212082 89.222130,202.669998
	C88.342224,208.389221 89.655807,214.445923 90.189331,221.103455
M259.070618,200.753738
	C258.505341,203.006317 257.758636,205.230789 257.404755,207.516098
	C255.363052,220.701187 262.015594,232.649384 272.871429,235.322845
	C280.940460,237.309998 287.472168,234.495941 293.249329,227.765976
	C293.626099,230.589005 293.895477,232.607162 294.168793,234.655090
	C296.653656,234.655090 298.890045,234.655090 300.991119,234.655090
	C300.991119,211.646210 300.991119,188.929199 300.991119,166.179596
	C298.045685,166.179596 295.499481,166.179596 292.702759,166.179596
	C292.702759,170.806625 292.702759,175.118011 292.702759,179.429398
	C292.702759,183.676865 292.702759,187.924347 292.702759,192.493027
	C277.722870,183.195663 266.492950,185.892761 259.070618,200.753738
M228.374451,226.384338
	C223.949707,223.176163 222.373459,218.645844 222.190399,213.043320
	C233.122681,213.043320 243.908295,213.043320 254.610199,213.043320
	C257.143036,201.668915 251.907181,190.984695 242.509964,187.837875
	C231.948578,184.301224 220.750259,189.515793 216.203506,200.087723
	C211.692795,210.575760 213.782867,223.603577 221.052597,230.313065
	C228.230469,236.937790 242.631256,237.971893 252.729233,232.434158
	C252.235092,230.679962 251.725082,228.869492 251.216537,227.064163
	C243.474747,229.193451 236.192307,230.650772 228.374451,226.384338
M311.837677,187.826202
	C311.209717,189.042618 310.066650,190.247116 310.038208,191.477417
	C309.865479,198.945114 309.945709,206.418716 309.943878,213.890335
	C309.942169,220.803711 309.943481,227.717087 309.943481,234.625061
	C313.118744,234.625061 315.670776,234.625061 318.324951,234.625061
	C318.324951,218.938263 318.324951,203.580017 318.324951,187.822433
	C316.268280,187.822433 314.474518,187.822433 311.837677,187.826202
M312.844421,179.767670
	C316.265350,180.117950 319.179047,178.920105 319.218719,175.342865
	C319.240143,173.414474 317.425354,170.392929 315.766571,169.823486
	C314.141602,169.265656 310.838806,170.608795 309.740265,172.158264
	C307.770660,174.936325 308.830505,177.827377 312.844421,179.767670
M382.345062,219.308533
	C383.194366,218.995178 384.763641,218.705795 384.774994,218.364563
	C384.843964,216.293671 384.557739,214.210938 384.390106,212.132172
	C383.569275,212.170502 382.748444,212.208847 381.927612,212.247192
	C381.927612,214.391342 381.927612,216.535477 382.345062,219.308533
M358.323730,237.979019
	C357.343414,238.220398 356.363068,238.461777 355.382751,238.703156
	C356.675537,240.258087 358.081207,240.960510 359.438416,240.876877
	C360.584869,240.806244 361.675171,239.824295 362.790344,239.245697
	C361.550262,238.785110 360.310211,238.324509 358.323730,237.979019
z"
      />
      <path
        fill="#0C0C0C"
        opacity="1.000000"
        stroke="none"
        d="
M207.006195,185.788467
	C208.027664,202.335587 209.031998,218.410080 210.051437,234.726364
	C207.119217,234.726364 204.682587,234.726364 201.618042,234.726364
	C200.679230,216.632141 199.742905,198.585770 198.741867,179.292267
	C195.219193,189.363754 192.111710,198.359192 188.924637,207.326324
	C186.197617,214.999039 183.354919,222.630585 180.615891,230.299088
	C179.758530,232.699478 179.183395,234.710892 175.654922,234.595047
	C172.101562,234.478439 171.770386,232.242981 171.011154,229.940659
	C166.222015,215.417755 161.448441,200.889709 156.641953,186.372543
	C156.357681,185.513977 155.832367,184.735199 154.326324,184.004501
	C153.307358,200.894821 152.288391,217.785156 151.262726,234.786469
	C148.474716,234.786469 146.167419,234.786469 143.157562,234.786469
	C144.669250,213.021072 146.173965,191.355957 147.662735,169.920578
	C148.354675,169.560760 148.626450,169.300720 148.907150,169.290665
	C158.383835,168.951431 158.504211,168.914062 161.566116,177.935333
	C166.268097,191.788773 170.782104,205.705994 175.390656,219.591248
	C175.645859,220.360214 176.035843,221.084457 176.300537,221.687103
	C182.545990,204.192474 188.788589,186.705841 194.970398,169.389496
	C198.874649,169.389496 202.179001,169.389496 205.887375,169.389496
	C206.260910,174.789352 206.624985,180.052597 207.006195,185.788467
z"
      />
      <path
        fill="#070707"
        opacity="1.000000"
        stroke="none"
        d="
M82.803772,233.258942
	C72.652664,233.267426 72.308136,233.354050 69.858391,223.610489
	C68.449928,218.008560 66.061172,216.058228 60.108143,216.375168
	C48.868076,216.973618 48.576244,216.486023 45.995808,227.286316
	C44.864262,232.022354 42.928326,234.043274 38.005978,233.333954
	C35.247158,232.936401 32.384071,233.262405 28.881853,233.262405
	C31.885336,223.428619 34.773304,213.993484 37.648373,204.554413
	C41.033764,193.439896 44.501083,182.348785 47.716297,171.185150
	C48.446507,168.649765 49.458160,167.654831 52.140297,167.782166
	C57.285664,168.026413 63.702217,166.097351 67.241379,168.512970
	C70.643860,170.835281 71.247169,177.456711 72.779617,182.284576
	C77.801918,198.107010 82.689980,213.972061 87.618477,229.824203
	C87.901207,230.733551 88.084709,231.673737 88.417824,233.016479
	C86.464539,233.108246 84.862053,233.183517 82.803772,233.258942
M53.007145,205.402374
	C56.949821,205.402374 60.892498,205.402374 65.340668,205.402374
	C62.853363,196.639130 60.543159,188.499832 57.960274,179.399841
	C55.609806,188.094254 53.532337,195.683960 51.550079,203.298447
	C51.397953,203.882812 51.917641,204.642044 53.007145,205.402374
z"
      />
      <path
        fill="#070707"
        opacity="1.000000"
        stroke="none"
        d="
M90.079987,220.726196
	C89.655807,214.445923 88.342224,208.389221 89.222130,202.669998
	C91.446510,188.212082 107.008507,178.859116 122.153412,188.893433
	C122.153412,180.742432 122.153412,172.844162 122.153412,164.577423
	C127.107780,164.577423 131.678360,164.577423 136.780518,164.577423
	C136.780518,187.228638 136.780518,210.057587 136.780518,233.080734
	C132.800095,233.080734 128.690842,233.080734 124.400513,233.080734
	C124.172241,231.134491 123.963676,229.356369 123.664482,226.805466
	C118.317764,233.431335 111.609123,235.541885 103.963623,233.784363
	C97.123787,232.212067 92.896828,227.380661 90.079987,220.726196
M103.869003,204.620026
	C104.299263,208.980209 104.045609,213.560028 105.355148,217.637833
	C106.624825,221.591507 110.550102,223.147980 114.754288,222.423538
	C119.230667,221.652176 121.697197,218.714066 122.101509,214.214401
	C122.309196,211.902893 122.238914,209.562469 122.223595,207.235596
	C122.181679,200.871185 119.782951,197.132401 115.167816,196.157089
	C110.396492,195.148758 106.589111,197.764908 103.869003,204.620026
z"
      />
      <path
        fill="#0A0A0A"
        opacity="1.000000"
        stroke="none"
        d="
M259.217285,200.393463
	C266.492950,185.892761 277.722870,183.195663 292.702759,192.493027
	C292.702759,187.924347 292.702759,183.676865 292.702759,179.429398
	C292.702759,175.118011 292.702759,170.806625 292.702759,166.179596
	C295.499481,166.179596 298.045685,166.179596 300.991119,166.179596
	C300.991119,188.929199 300.991119,211.646210 300.991119,234.655090
	C298.890045,234.655090 296.653656,234.655090 294.168793,234.655090
	C293.895477,232.607162 293.626099,230.589005 293.249329,227.765976
	C287.472168,234.495941 280.940460,237.309998 272.871429,235.322845
	C262.015594,232.649384 255.363052,220.701187 257.404755,207.516098
	C257.758636,205.230789 258.505341,203.006317 259.217285,200.393463
M265.906616,212.385773
	C266.284058,214.667313 266.382629,217.039688 267.090729,219.213501
	C269.290131,225.965256 274.594299,229.581573 280.931610,228.943268
	C287.310150,228.300827 292.162659,223.167374 292.621796,216.112442
	C292.868530,212.321213 292.857880,208.449326 292.376099,204.689072
	C291.589355,198.548752 287.417206,194.533447 281.781525,193.817245
	C275.671112,193.040695 270.406036,195.671188 268.098846,201.393280
	C266.828644,204.543564 266.606659,208.116501 265.906616,212.385773
z"
      />
      <path
        fill="#0B0B0B"
        opacity="1.000000"
        stroke="none"
        d="
M228.684998,226.610474
	C236.192307,230.650772 243.474747,229.193451 251.216537,227.064163
	C251.725082,228.869492 252.235092,230.679962 252.729233,232.434158
	C242.631256,237.971893 228.230469,236.937790 221.052597,230.313065
	C213.782867,223.603577 211.692795,210.575760 216.203506,200.087723
	C220.750259,189.515793 231.948578,184.301224 242.509964,187.837875
	C251.907181,190.984695 257.143036,201.668915 254.610199,213.043320
	C243.908295,213.043320 233.122681,213.043320 222.190399,213.043320
	C222.373459,218.645844 223.949707,223.176163 228.684998,226.610474
M237.456619,206.845520
	C240.572052,206.845520 243.687485,206.845520 246.782898,206.845520
	C247.006607,198.375900 242.987122,193.373169 236.082565,193.010788
	C228.655518,192.620987 223.445190,197.813995 222.611084,206.845551
	C227.256424,206.845551 231.866455,206.845551 237.456619,206.845520
z"
      />
      <path
        fill="#0B0B0B"
        opacity="1.000000"
        stroke="none"
        d="
M360.747467,234.872437
	C358.486389,234.857086 356.225342,234.841736 353.573059,234.388336
	C353.032898,232.526764 352.884003,231.103226 352.708191,229.422577
	C349.965118,231.377609 347.474152,233.152969 344.983185,234.928329
	C343.522888,235.223267 342.073181,235.593307 340.600555,235.800446
	C333.127197,236.851654 326.599670,233.343002 324.385895,227.130493
	C321.951691,220.299377 324.506866,212.580444 331.353027,209.257812
	C335.869843,207.065689 341.109955,206.317230 346.073303,205.117188
	C347.795532,204.700775 349.659454,204.870209 351.429291,204.773682
	C352.172119,193.474884 344.386047,190.478058 328.808075,196.126129
	C328.183777,194.536835 327.554382,192.934525 326.794769,191.000732
	C334.481323,186.733398 342.287170,185.407547 350.400909,188.204834
	C356.782288,190.404846 359.550323,195.704620 360.018066,202.093231
	C360.405853,207.390625 360.234619,212.728943 360.291809,218.952545
	C360.430878,224.861465 360.589172,229.866959 360.747467,234.872437
M335.814545,214.207352
	C331.739838,218.366486 330.979614,222.801590 333.693329,226.582947
	C336.101776,229.938980 341.702026,230.546143 346.343628,227.954453
	C351.708832,224.958740 353.357208,219.377151 351.103668,209.995270
	C346.212036,211.260437 341.335968,212.521576 335.814545,214.207352
z"
      />
      <path
        fill="#101010"
        opacity="1.000000"
        stroke="none"
        d="
M312.259216,187.824310
	C314.474518,187.822433 316.268280,187.822433 318.324951,187.822433
	C318.324951,203.580017 318.324951,218.938263 318.324951,234.625061
	C315.670776,234.625061 313.118744,234.625061 309.943481,234.625061
	C309.943481,227.717087 309.942169,220.803711 309.943878,213.890335
	C309.945709,206.418716 309.865479,198.945114 310.038208,191.477417
	C310.066650,190.247116 311.209717,189.042618 312.259216,187.824310
z"
      />
      <path
        fill="#F4F1E6"
        opacity="1.000000"
        stroke="none"
        d="
M361.153809,234.938690
	C360.589172,229.866959 360.430878,224.861465 360.388062,219.409271
	C363.829559,218.308212 367.200134,216.977524 370.468994,217.192612
	C373.641632,217.401382 378.960846,218.668488 379.367981,220.402695
	C380.292297,224.339874 379.551117,229.148193 378.046417,233.046295
	C376.400421,237.310486 371.961975,237.661774 367.768250,236.744064
	C365.672394,236.285431 363.627899,235.592133 361.153809,234.938690
M368.064728,219.102798
	C363.693817,220.649765 362.450592,224.044266 363.112793,228.194611
	C363.657593,231.609116 365.742401,233.819992 369.407410,234.161774
	C374.363251,234.623932 377.646088,231.758545 377.924774,226.715607
	C378.198364,221.765106 374.895447,218.929276 368.064728,219.102798
z"
      />
      <path
        fill="#101010"
        opacity="1.000000"
        stroke="none"
        d="
M312.486694,179.613358
	C308.830505,177.827377 307.770660,174.936325 309.740265,172.158264
	C310.838806,170.608795 314.141602,169.265656 315.766571,169.823486
	C317.425354,170.392929 319.240143,173.414474 319.218719,175.342865
	C319.179047,178.920105 316.265350,180.117950 312.486694,179.613358
z"
      />
      <path
        fill="#F4F1E6"
        opacity="1.000000"
        stroke="none"
        d="
M345.136292,235.237381
	C347.474152,233.152969 349.965118,231.377609 352.708191,229.422577
	C352.884003,231.103226 353.032898,232.526764 353.154114,234.316406
	C353.059296,235.326599 352.992188,235.970703 352.893280,236.919830
	C350.354462,236.461288 347.821930,236.003860 345.136292,235.237381
z"
      />
      <path
        fill="#F4F1E6"
        opacity="1.000000"
        stroke="none"
        d="
M382.136353,218.994080
	C381.927612,216.535477 381.927612,214.391342 381.927612,212.247192
	C382.748444,212.208847 383.569275,212.170502 384.390106,212.132172
	C384.557739,214.210938 384.843964,216.293671 384.774994,218.364563
	C384.763641,218.705795 383.194366,218.995178 382.136353,218.994080
z"
      />
      <path
        fill="#F4F1E6"
        opacity="1.000000"
        stroke="none"
        d="
M358.696930,237.921478
	C360.310211,238.324509 361.550262,238.785110 362.790344,239.245697
	C361.675171,239.824295 360.584869,240.806244 359.438416,240.876877
	C358.081207,240.960510 356.675537,240.258087 355.382751,238.703156
	C356.363068,238.461777 357.343414,238.220398 358.696930,237.921478
z"
      />
      <path
        fill="#F2F2F2"
        opacity="1.000000"
        stroke="none"
        d="
M52.566105,205.361191
	C51.917641,204.642044 51.397953,203.882812 51.550079,203.298447
	C53.532337,195.683960 55.609806,188.094254 57.960274,179.399841
	C60.543159,188.499832 62.853363,196.639130 65.340668,205.402374
	C60.892498,205.402374 56.949821,205.402374 52.566105,205.361191
z"
      />
      <path
        fill="#F7F7F7"
        opacity="1.000000"
        stroke="none"
        d="
M103.936890,204.223755
	C106.589111,197.764908 110.396492,195.148758 115.167816,196.157089
	C119.782951,197.132401 122.181679,200.871185 122.223595,207.235596
	C122.238914,209.562469 122.309196,211.902893 122.101509,214.214401
	C121.697197,218.714066 119.230667,221.652176 114.754288,222.423538
	C110.550102,223.147980 106.624825,221.591507 105.355148,217.637833
	C104.045609,213.560028 104.299263,208.980209 103.936890,204.223755
z"
      />
      <path
        fill="#FAFAFA"
        opacity="1.000000"
        stroke="none"
        d="
M265.909363,211.942337
	C266.606659,208.116501 266.828644,204.543564 268.098846,201.393280
	C270.406036,195.671188 275.671112,193.040695 281.781525,193.817245
	C287.417206,194.533447 291.589355,198.548752 292.376099,204.689072
	C292.857880,208.449326 292.868530,212.321213 292.621796,216.112442
	C292.162659,223.167374 287.310150,228.300827 280.931610,228.943268
	C274.594299,229.581573 269.290131,225.965256 267.090729,219.213501
	C266.382629,217.039688 266.284058,214.667313 265.909363,211.942337
z"
      />
      <path
        fill="#F3F3F3"
        opacity="1.000000"
        stroke="none"
        d="
M236.966553,206.845535
	C231.866455,206.845551 227.256424,206.845551 222.611084,206.845551
	C223.445190,197.813995 228.655518,192.620987 236.082565,193.010788
	C242.987122,193.373169 247.006607,198.375900 246.782898,206.845520
	C243.687485,206.845520 240.572052,206.845520 236.966553,206.845535
z"
      />
      <path
        fill="#F7F7F7"
        opacity="1.000000"
        stroke="none"
        d="
M336.137238,213.995026
	C341.335968,212.521576 346.212036,211.260437 351.103668,209.995270
	C353.357208,219.377151 351.708832,224.958740 346.343628,227.954453
	C341.702026,230.546143 336.101776,229.938980 333.693329,226.582947
	C330.979614,222.801590 331.739838,218.366486 336.137238,213.995026
z"
      />
      <path
        fill="#E0964F"
        opacity="1.000000"
        stroke="none"
        d="
M368.460144,219.015839
	C374.895447,218.929276 378.198364,221.765106 377.924774,226.715607
	C377.646088,231.758545 374.363251,234.623932 369.407410,234.161774
	C365.742401,233.819992 363.657593,231.609116 363.112793,228.194611
	C362.450592,224.044266 363.693817,220.649765 368.460144,219.015839
M375.024689,224.870697
	C374.257202,221.794006 372.208344,219.866699 369.347504,221.531387
	C367.471466,222.623047 365.572815,225.374741 365.558655,227.396103
	C365.548462,228.848709 368.562012,231.431076 370.354950,231.548325
	C373.703003,231.767303 375.703949,229.446030 375.024689,224.870697
z"
      />
      <path
        fill="#F97F0C"
        opacity="1.000000"
        stroke="none"
        d="
M375.038025,225.283203
	C375.703949,229.446030 373.703003,231.767303 370.354950,231.548325
	C368.562012,231.431076 365.548462,228.848709 365.558655,227.396103
	C365.572815,225.374741 367.471466,222.623047 369.347504,221.531387
	C372.208344,219.866699 374.257202,221.794006 375.038025,225.283203
z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdMedia);
